var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThunderstorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fad",
    "data-icon": "thunderstorm",
    className: "svg-inline--fa fa-thunderstorm fa-w-16",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fa-group"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fa-secondary",
    fill: "currentColor",
    d: "M350 310.5l-98 194a15 15 0 0 1-27.6-11L256 352h-81a15 15 0 0 1-14.9-17l16-130a15.08 15.08 0 0 1 14.9-13h82a15 15 0 0 1 14.5 18.9L264.92 288H337a15 15 0 0 1 13 22.5z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "fa-primary",
    fill: "currentColor",
    d: "M512 224a96 96 0 0 1-96 96h-30a46.78 46.78 0 0 0-45-60h-30.5l10.9-40.9A47 47 0 0 0 276 160h-85a47.1 47.1 0 0 0-46.6 40.8L128.5 320H96a96 96 0 0 1-96-96c0-42.5 27.8-78.2 66.1-90.8A113.72 113.72 0 0 1 64 112 111.94 111.94 0 0 1 176 0c43.3 0 80.4 24.8 99 60.8C289.7 43.3 311.4 32 336 32a80 80 0 0 1 80 80 78.09 78.09 0 0 1-1.6 16.2c.5 0 1-.2 1.6-.2a96 96 0 0 1 96 96z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstorm);
export default __webpack_public_path__ + "static/media/thunderstorm.8d0a83d6f833ef52a6865d007dc72e24.svg";
export { ForwardRef as ReactComponent };